import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  accessOkResponseSchema,
  sessionResponseSchema,
  signInOptionsSchema,
  type SessionResponse,
} from "../contracts/index";
import { ApiError, POLL_MS, apiGet, apiPost } from "@amber/ui";
import { sessionKeys } from "./keys";

export const sessionQuery = queryOptions({
  queryKey: sessionKeys.session,
  queryFn: ({ signal }) => apiGet("/api/session", sessionResponseSchema, signal),
  refetchInterval: POLL_MS,
  retry: (count, error) => !(error instanceof ApiError && error.status === 401) && count < 2,
  staleTime: 5_000,
});

export const signInOptionsQuery = queryOptions({
  queryKey: sessionKeys.authOptions,
  queryFn: ({ signal }) => apiGet("/api/auth/options", signInOptionsSchema, signal),
  staleTime: 60_000,
});

export function useSession(): SessionResponse | undefined {
  return useQuery(sessionQuery).data;
}

export function useCsrfToken(): () => string | null {
  const client = useQueryClient();
  return () => client.getQueryData<SessionResponse>(sessionQuery.queryKey)?.csrf_token ?? null;
}

export async function signOut(csrfToken: string | null): Promise<void> {
  await apiPost("/api/auth/sign-out", {}, accessOkResponseSchema, csrfToken);
}

export async function devSignIn(role: string, csrfToken: string | null): Promise<void> {
  await apiPost("/api/dev/sign-in", { role }, accessOkResponseSchema, csrfToken);
}
